import { Config } from "src/Utils/ConfigService/LoadConfig";
import { usePostRequest } from "../ApiWrappers/usePostRequest";
import { useCallback, useEffect, useRef, useState } from "react";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";
export interface IUpgradeSubscription {
    upgradeSuccess: boolean;
    hostedInvoiceUrl: string;
}
export const useUpgradeSubscription = () => {
    const { postRequest, reqestResponse, reqestError, reqestLoading } = usePostRequest();
    const baseUrl = Config.GetConfigData().auraLicensingService.serviceUrl;
    const clinicIdRef = useRef<string>('');
    const [upgradeResponse, setUpgradeResponse] = useState<IUpgradeSubscription>({ upgradeSuccess: false, hostedInvoiceUrl: '' })

    const upgradeSubscription = useCallback((clinicId: string, priceId: string, upcomingInvoiceId: string) => {
        setUpgradeResponse({ upgradeSuccess: false, hostedInvoiceUrl: '' });
        const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/upgrade?upcomingInvoiceId=${upcomingInvoiceId}`;
        logger.logInformation(`Request to upgrade subscription license for the given clinic ${clinicId} was made`);
        postRequest<string>(priceId, requestUrl);
        clinicIdRef.current = clinicId;
    }, [baseUrl, postRequest]);

    useEffect(() => {
        if (reqestResponse) {
            var upgradeSuccess: IUpgradeSubscription = {
                upgradeSuccess: reqestResponse.upgradeSuccess,
                hostedInvoiceUrl: reqestResponse.hostedInvoiceUrl
            }
            logger.logInformation(`UpgradeSubscription: ${upgradeSuccess}`);
            setUpgradeResponse(upgradeSuccess);
        }
    }, [reqestResponse]);
    return { upgradeResponse, reqestError, reqestLoading, upgradeSubscription };
}
